var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("skp-breadcrumbs", {
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt10" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.BASIC.INFO")))
        ]),
        _vm._v(" "),
        _vm.getIsDetail
          ? _c("table", { staticClass: "create_table" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBSIDIARY"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { colspan: "3", "data-input-type": "select" } },
                    [
                      _c(
                        "fieldset",
                        { staticClass: "ui_fieldset set_2 input-58" },
                        [
                          _c("div", [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.RHQ_CD,
                                    expression: "RHQ_CD"
                                  },
                                  {
                                    name: "validation",
                                    rawName: "v-validation",
                                    value: { groupId: "basic" },
                                    expression: "{ groupId: 'basic' }"
                                  }
                                ],
                                staticClass: "slt_white w100",
                                attrs: { id: "RHQ_CD", name: "RHQ_CD" },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.RHQ_CD = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      return _vm.changeRhqCd($event)
                                    }
                                  ]
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "",
                                      disabled: "",
                                      selected: ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "FIELD.GLOBAL.OPTION.DETAIL.NAME"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.rhqCdList, function(item, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: item.code,
                                      domProps: { value: item.code }
                                    },
                                    [_vm._v(_vm._s(item.codeName))]
                                  )
                                })
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.CORP_NO,
                                    expression: "CORP_NO"
                                  },
                                  {
                                    name: "validation",
                                    rawName: "v-validation",
                                    value: { groupId: "basic" },
                                    expression: "{ groupId: 'basic' }"
                                  }
                                ],
                                staticClass: "slt_white w100",
                                attrs: { id: "CORP_NO", name: "CORP_NO" },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.CORP_NO = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      return _vm.changeCorpCd($event)
                                    }
                                  ]
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "",
                                      disabled: "",
                                      selected: ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "FIELD.GLOBAL.OPTION.DETAIL.NAME"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.corpCdList, function(item, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: item.code,
                                      domProps: { value: item.code }
                                    },
                                    [_vm._v(_vm._s(item.codeName))]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.BOARD_TYPE1,
                                expression: "BOARD_TYPE1"
                              }
                            ],
                            staticClass: "slt_white w100",
                            attrs: { id: "BOARD_TYPE1", name: "BOARD_TYPE1" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.BOARD_TYPE1 = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.changeBoardType1($event)
                                }
                              ]
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME")
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.boardType1List, function(item) {
                              return _c(
                                "option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.boardType1List.length > 0,
                                      expression: "boardType1List.length > 0"
                                    }
                                  ],
                                  key: item.code,
                                  domProps: { value: item.code }
                                },
                                [_vm._v(_vm._s(item.codeName))]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.BOARD_TYPE2,
                                expression: "BOARD_TYPE2"
                              }
                            ],
                            staticClass: "slt_white w100",
                            attrs: { id: "BOARD_TYPE2", name: "BOARD_TYPE2" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.BOARD_TYPE2 = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME")
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.boardType2List, function(item) {
                              return _c(
                                "option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.boardType2List.length > 0,
                                      expression: "boardType2List.length > 0"
                                    }
                                  ],
                                  key: item.code,
                                  attrs: {
                                    "data-menu-grp-dtl-cd": item.menuGrpDtlCd
                                  },
                                  domProps: { value: item.code }
                                },
                                [_vm._v(_vm._s(item.codeName))]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.ADMIN.MENU.ORDER")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.NEXT_ORDER1,
                                expression: "NEXT_ORDER1"
                              }
                            ],
                            staticClass: "slt_white w100",
                            attrs: { id: "NEXT_ORDER1", name: "NEXT_ORDER1" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.NEXT_ORDER1 = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.changeOrder($event)
                                }
                              ]
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [_vm._v(_vm._s(_vm.$t("FIELD.NEXT.OF")))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.nextOrder1List, function(item) {
                              return _c(
                                "option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.nextOrder1List.length > 0,
                                      expression: "nextOrder1List.length > 0"
                                    }
                                  ],
                                  key: item.code,
                                  domProps: { value: item.code }
                                },
                                [_vm._v(_vm._s(item.codeName))]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.NEXT_ORDER2,
                                expression: "NEXT_ORDER2"
                              }
                            ],
                            staticClass: "slt_white w100",
                            attrs: { id: "NEXT_ORDER2", name: "NEXT_ORDER2" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.NEXT_ORDER2 = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [_vm._v(_vm._s(_vm.$t("FIELD.NEXT.OF")))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.nextOrder2List, function(item) {
                              return _c(
                                "option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.nextOrder2List.length > 0,
                                      expression: "nextOrder2List.length > 0"
                                    }
                                  ],
                                  key: item.code,
                                  domProps: { value: item.code }
                                },
                                [_vm._v(_vm._s(item.codeName))]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.BOARD.NAME.E"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.BOARD_NM_EN,
                          expression: "BOARD_NM_EN"
                        },
                        {
                          name: "validation",
                          rawName: "v-validation",
                          value: { groupId: "basic" },
                          expression: "{ groupId: 'basic' }"
                        }
                      ],
                      staticClass: "text_input w100",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("FIELD.ADMIN.BOARD.NAME.E")
                      },
                      domProps: { value: _vm.BOARD_NM_EN },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.BOARD_NM_EN = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.BOARD.NAME.LOCAL"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.BOARD_NM,
                          expression: "BOARD_NM"
                        },
                        {
                          name: "validation",
                          rawName: "v-validation",
                          value: { groupId: "basic" },
                          expression: "{ groupId: 'basic' }"
                        }
                      ],
                      staticClass: "text_input w100",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("FIELD.ADMIN.BOARD.NAME.LOCAL")
                      },
                      domProps: { value: _vm.BOARD_NM },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.BOARD_NM = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.BOARD.DESCRIPTION.E")))
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.BOARD_DESC_EN,
                          expression: "BOARD_DESC_EN"
                        }
                      ],
                      staticClass: "text_textarea w100",
                      attrs: {
                        placeholder: _vm.$t("FIELD.ADMIN.BOARD.DESCRIPTION.E")
                      },
                      domProps: { value: _vm.BOARD_DESC_EN },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.BOARD_DESC_EN = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.BOARD_DESC,
                          expression: "BOARD_DESC"
                        }
                      ],
                      staticClass: "text_textarea w100",
                      attrs: {
                        placeholder: _vm.$t(
                          "FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL"
                        )
                      },
                      domProps: { value: _vm.BOARD_DESC },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.BOARD_DESC = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.DISCAEDED.PERIOD")))
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.DISCARDED_PERIOD,
                            expression: "DISCARDED_PERIOD",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "slt_white input-58",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return _vm._n(val)
                              })
                            _vm.DISCARDED_PERIOD = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALL")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.discardedPreiodList, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.discardedPreiodList.length > 0,
                                  expression: "discardedPreiodList.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt25" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.LIST.INFO")))
        ]),
        _vm._v(" "),
        _vm.getIsDetail
          ? _c("table", { staticClass: "create_table" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.MAX.OF.COUNT")))
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { "data-input-type": "input" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.LIST_CNT,
                          expression: "LIST_CNT",
                          modifiers: { number: true }
                        }
                      ],
                      staticClass: "text_input w100",
                      attrs: {
                        type: "number",
                        placeholder: _vm.$t("FIELD.ADMIN.MAX.OF.COUNT")
                      },
                      domProps: { value: _vm.LIST_CNT },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.LIST_CNT = _vm._n($event.target.value)
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "2" } })
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt25" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.DETAIL.INFO")))
        ]),
        _vm._v(" "),
        _vm.getIsDetail
          ? _c("table", { staticClass: "create_table" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.ADMIN.VERIFY")))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { "data-input-type": "checkbox", colspan: "3" } },
                    [
                      _c("label", { staticClass: "checkbox-wrap mr10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.VERIFY_USE_YN,
                              expression: "VERIFY_USE_YN"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.VERIFY_USE_YN)
                              ? _vm._i(_vm.VERIFY_USE_YN, null) > -1
                              : _vm.VERIFY_USE_YN
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.VERIFY_USE_YN,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.VERIFY_USE_YN = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.VERIFY_USE_YN = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.VERIFY_USE_YN = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "check-icon" }),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.USE")))])
                      ])
                    ]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt25" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.REGISTER.INFO")))
        ]),
        _vm._v(" "),
        _vm.getIsDetail
          ? _c("table", { staticClass: "create_table" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("tbody", [
                typeof _vm.detail.REG_USER_NM !== "undefined"
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.REGISTERED.BY")))
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-input-type": "text" } }, [
                        _vm._v(_vm._s(_vm.detail.REG_USER_NM))
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.REGISTERED.DATE")))
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-input-type": "text" } }, [
                        _vm._v(_vm._s(_vm.detail.REG_DT))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                typeof _vm.detail.MODF_USER_NM !== "undefined"
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.UPDATED.BY")))
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-input-type": "text" } }, [
                        _vm._v(_vm._s(_vm.detail.MODF_USER_NM))
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.UPDATED.DATE")))
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-input-type": "text" } }, [
                        _vm._v(_vm._s(_vm.detail.MODF_DT))
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "sub_head_Warp" }, [
          _c("div", { staticClass: "sub_tit mt25" }, [
            _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.LIST.COLUMN")))
          ]),
          _vm._v(" "),
          this.sysAdmYn == "Y"
            ? _c("div", { staticClass: "btn_wrap" }, [
                _c("a", {
                  staticClass: "btn_white btnUp",
                  attrs: { href: "javascript:", title: "" },
                  on: { click: _vm.btnColUp }
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "btn_white btnDown",
                  attrs: { href: "javascript:", title: "" },
                  on: { click: _vm.btnColDown }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:", title: "" },
                    on: { click: _vm.btnColAdd }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.ADD")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:", title: "" },
                    on: { click: _vm.btnColDelete }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "scroll_table" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "w10" }, [
                _c("label", { staticClass: "checkbox-wrap" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    on: {
                      click: function($event) {
                        return _vm.chkAllHeaderList($event)
                      }
                    }
                  }),
                  _c("i", { staticClass: "check-icon" })
                ])
              ]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.COLUMN")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.ADMIN.HEADER.NAME")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.WIDTH")) + " (%)")]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALIGN")))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm.headerList.length === 0 || _vm.tableHeaderList.length === 0
                ? _c("tr", [
                    _c("td", { staticClass: "tC", attrs: { colspan: "5" } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("FIELD.GLOBAL.NODATA")) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._l(_vm.headerList, function(header, idx) {
                    return _c("tr", [
                      _c("td", { staticClass: "tC w10" }, [
                        _c(
                          "label",
                          {
                            staticClass: "checkbox-wrap",
                            attrs: { for: header.BOARD_HEADER_ID }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selHeaderList,
                                  expression: "selHeaderList"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                id: header.BOARD_HEADER_ID,
                                name: header.BOARD_HEADER_ID
                              },
                              domProps: {
                                value: header.BOARD_HEADER_ID,
                                checked: Array.isArray(_vm.selHeaderList)
                                  ? _vm._i(
                                      _vm.selHeaderList,
                                      header.BOARD_HEADER_ID
                                    ) > -1
                                  : _vm.selHeaderList
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.selHeaderList,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = header.BOARD_HEADER_ID,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selHeaderList = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selHeaderList = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selHeaderList = $$c
                                  }
                                }
                              }
                            }),
                            _c("i", { staticClass: "check-icon" })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tC" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: header.HEADER_COLUMN,
                                expression: "header.HEADER_COLUMN"
                              }
                            ],
                            staticClass: "slt_white w100",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  header,
                                  "HEADER_COLUMN",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME")
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.tableHeaderList, function(item) {
                              return _c(
                                "option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tableHeaderList.length > 0,
                                      expression: "tableHeaderList.length > 0"
                                    }
                                  ],
                                  domProps: { value: item.code }
                                },
                                [_vm._v(_vm._s(item.codeName))]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tC" }, [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: header.HEADER_NAME,
                                expression: "header.HEADER_NAME"
                              }
                            ],
                            staticClass: "text_input w100",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("FIELD.ADMIN.HEADER.NAME")
                            },
                            domProps: { value: header.HEADER_NAME },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  header,
                                  "HEADER_NAME",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tC" }, [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: header.HEADER_WIDTH,
                                expression: "header.HEADER_WIDTH"
                              }
                            ],
                            staticClass: "text_input w100",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("FIELD.GLOBAL.WIDTH")
                            },
                            domProps: { value: header.HEADER_WIDTH },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  header,
                                  "HEADER_WIDTH",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tC" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: header.HEADER_ALIGN,
                                expression: "header.HEADER_ALIGN"
                              }
                            ],
                            staticClass: "slt_white w100",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  header,
                                  "HEADER_ALIGN",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME")
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "L" } }, [
                              _vm._v("Left")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "C" } }, [
                              _vm._v("Center")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "R" } }, [
                              _vm._v("Right")
                            ])
                          ]
                        )
                      ])
                    ])
                  })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt25 w100" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.AUTHORIZATION")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tab_wrap" }, [
          _c("ul", { staticClass: "tab_menu_02 tab_menus" }, [
            _c("li", { staticClass: "on" }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:", "data-id": "role" },
                  on: {
                    click: function($event) {
                      return _vm.setTabName($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("FIELD.USER.ROLE")))]
              )
            ]),
            _vm._v(" "),
            _c("li", {}, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:", "data-id": "user" },
                  on: {
                    click: function($event) {
                      return _vm.setTabName($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.USER")))]
              )
            ]),
            _vm._v(" "),
            this.sysAdmYn == "Y"
              ? _c("div", { staticClass: "btn_wrap fR" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_sm_white",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.btnAuthAdd }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.ADD")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn_sm_white",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.btnAuthDelete }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab_contents_list" }, [
            _c("div", { staticClass: "tab_cont" }, [
              _c("table", { staticClass: "scroll_table" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "w10" }, [
                      _c("label", { staticClass: "checkbox-wrap" }, [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          on: { click: _vm.chkAllAuthList }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "check-icon" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ID")))]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ROLE.NAME")))
                    ]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CREATION")))])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm.resultAuth.length === 0
                      ? _c("tr", [
                          _c("td", { staticClass: "tC" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("FIELD.GLOBAL.NODATA")) +
                                "\n                                "
                            )
                          ])
                        ])
                      : _vm._l(_vm.resultAuth, function(auth, idx) {
                          return _c("tr", [
                            _c("td", { staticClass: "tC w10" }, [
                              _c("label", { staticClass: "checkbox-wrap" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selResultAuth,
                                      expression: "selResultAuth"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: auth.AUTHCORPID,
                                    checked: Array.isArray(_vm.selResultAuth)
                                      ? _vm._i(
                                          _vm.selResultAuth,
                                          auth.AUTHCORPID
                                        ) > -1
                                      : _vm.selResultAuth
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.selResultAuth,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = auth.AUTHCORPID,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selResultAuth = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selResultAuth = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selResultAuth = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "check-icon" })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "tC" }, [
                              _vm._v(_vm._s(auth.AUTHID))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "tC" }, [
                              _vm._v(_vm._s(auth.AUTHNM))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "tC" }, [
                              _vm._v(_vm._s(auth.CREATIONYN))
                            ])
                          ])
                        })
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab_cont", staticStyle: { display: "none" } },
              [
                _c("table", { staticClass: "scroll_table" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "w10" }, [
                        _c("label", { staticClass: "checkbox-wrap" }, [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            on: { click: _vm.chkAllAuthList }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ID")))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.USER.NAME")))]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CREATION")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm.resultUser.length === 0
                        ? _c("tr", [
                            _c("td", { staticClass: "tC" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("FIELD.GLOBAL.NODATA")) +
                                  "\n                                "
                              )
                            ])
                          ])
                        : _vm._l(_vm.resultUser, function(user, idx) {
                            return _c("tr", [
                              _c("td", { staticClass: "tC w10" }, [
                                _c("label", { staticClass: "checkbox-wrap" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selResultUser,
                                        expression: "selResultUser"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: user.LOGINID,
                                      checked: Array.isArray(_vm.selResultUser)
                                        ? _vm._i(
                                            _vm.selResultUser,
                                            user.LOGINID
                                          ) > -1
                                        : _vm.selResultUser
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.selResultUser,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = user.LOGINID,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selResultUser = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selResultUser = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selResultUser = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "check-icon" })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "tC" }, [
                                _vm._v(_vm._s(user.LOGINID))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "tC" }, [
                                _vm._v(_vm._s(user.LOGINNM))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "tC" }, [
                                _vm._v(_vm._s(user.CREATIONYN))
                              ])
                            ])
                          })
                    ],
                    2
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full" }, [
          _c(
            "a",
            {
              staticClass: "btn_white size_full",
              attrs: { href: "javascript:" },
              on: { click: _vm.btnList }
            },
            [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LIST")))]
          ),
          _vm._v(" "),
          _vm.sysAdmYn == "Y"
            ? _c("div", { staticClass: "btn_right" }, [
                _vm.STATUS === "R"
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "javascript:" },
                        on: { click: _vm.btnStart }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SERVICE.START")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.superUser === "Y"
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "javascript:" },
                        on: { click: _vm.btnSave }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.superUser === "Y"
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "javascript:" },
                        on: { click: _vm.btnDelete }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2815fd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2815fd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/knowledgeManager/boardManage/BoardManageDetail.vue
// module id = bkYL
// module chunks = 0